export const testimonials = [
  {
    name: '游戏达人小明',
    rating: 5,
    content: '玩了三年踩蘑菇，从菜鸟变成了排行榜前十！这个网站的攻略太详细了，尤其是反弹跳的教程，看完之后技术突飞猛进。推荐所有踩蘑菇玩家收藏这个宝藏网站。',
    date: '2026-07-30',
  },
  {
    name: '休闲玩家小红',
    rating: 5,
    content: '本来以为这个游戏很难，看了新手教程之后发现其实很好上手。现在每天午休都要玩两把，已经通到第七关了！网站的分类很清晰，找攻略特别方便。',
    date: '2026-07-28',
  },
  {
    name: '技术流老张',
    rating: 4,
    content: '隐藏要素那篇文章写得真好，我按攻略找到了倒置世界，设计得简直绝了！唯一的小建议是希望能出更多关于Boss打法的深度分析，第十关Boss第三阶段我还是有点吃力。',
    date: '2026-07-25',
  },
  {
    name: '速通选手阿杰',
    rating: 5,
    content: '速通攻略那篇帮我从18分钟突破到了14分钟，虽然离世界纪录还有距离，但进步很明显。线路规划部分特别实用，直接照着走效率高了很多。感谢作者用心的内容。',
    date: '2026-07-22',
  },
  {
    name: '宝妈玩家小芳',
    rating: 5,
    content: '带娃间隙玩的，手游版操作优化指南帮了大忙！按文章说的调节了按键位置和灵敏度之后，手感好了很多。现在哄孩子睡觉之后玩半小时踩蘑菇是我每天的放松时刻。',
    date: '2026-07-20',
  },
  {
    name: '新玩家大刘',
    rating: 5,
    content: '朋友推荐了这款游戏，刚玩两天就被下载排行榜吸引了。这个网站的新手教程让我少走了好多弯路，前五关攻略也超详细。现在已经是忠实玩家了，逢人就安利踩蘑菇！',
    date: '2026-07-18',
  },
];